module.exports = __webpack_public_path__ + "img/usdt.bae12c5d.png";